<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons')

const animationDuration = 6000

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    chartData: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: 'title'
    },
    label: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    label() {
      this.setOptions()
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions()
    },
    setOptions() {
      this.chart.setOption({
        title: {
          text: this.title
        },
        tooltip: {
          backgroundColor: `rgba(30,0,0,0.8)`,
          textStyle: {
            color: 'white'
          }
        },
        xAxis: {
          data: this.label
        },
        yAxis: {},
        series: [this.chartData]
      })
    }
  }
}
</script>
